import { ChangeDetectionStrategy, ChangeDetectorRef, Component, OnInit } from '@angular/core';
import { FieldType } from '@ngx-formly/core';
import { AddressService } from '../../services/address.service';


@Component({
  selector: 'formly-crm-address-lookup',
  changeDetection: ChangeDetectionStrategy.OnPush,
  templateUrl: './formly-crm-address-lookup.component.html',
  standalone: true,

})
export class FormlyCrmAddressLookupComponent extends FieldType implements OnInit {

  // @ViewChild('lookup', { static: true }) companyContactLinkWidget: DxLookupComponent;
  // lookupDataSource: any = {};

  externalLinkUrl: string;

  constructor(private cdRef: ChangeDetectorRef, private addressService: AddressService) {
    super();

  }

  ngOnInit() {
    this.load();
  }

  async load() {
    // let store = await this.companyService.asDevExtremeSource();

    // this.lookupDataSource = new DataSource({
    //   store: store,
    //   paginate: true,
    //   pageSize: 10
    // });

    // this.companyContactLinkWidget.displayExpr = function (data) {
    //   if (data)
    //     return data.debitorId + " - " + data.name;
    //   return null;
    // }


    // this.companyContactLinkWidget.itemTemplate = function (data: Company, index, _: DevExpress.core.dxElement) {
    //   _.innerHTML = `${data.debitorId} - ${data.name} <i>${data.homepage != null ? " - " + data.homepage : ''}</i>`;
    // }


    // this.companyContactLinkWidget.fieldTemplate = function (data) {
    //   if (data) {

    //   }
    //   return null;
    // }


    if (this.formControl.value) {
      // this.companyContactLinkWidget.value = this.formControl.value;
      // this.companyContactLinkWidget.writeValue(this.formControl.value);
      this.postLoad();
    }

    this.formControl.valueChanges.subscribe(x => {
      console.log(x);

    });
  }

  onValueChanged(e) {
    let previousValue = e.previousValue;
    let id = e.value.id;
    this.formControl.setValue(e.value);
    this.postLoad();
    // Event handling commands go here
  }

  postLoad() {
    this.externalLinkUrl = "/crm/company/" + this.formControl.value.id;
    this.cdRef.detectChanges();
  }

  check() {
    // console.log('formly company lookup component view checked');
  }

  openLink() {

  }
}